define('lunch',['jquery', 'event-manager', 'underscore', 'lib'], function($, eventManager, _, lib) {
    'use strict';

    function getFormattedDate(dateObj) {
        // Pad month and date to two digits
        var month = (dateObj.getMonth() + 1) + '';
        month = month.length < 2 ? '0' + month : month;
        var date = dateObj.getDate() + '';
        date = date.length < 2 ? '0' + date : date;

        return dateObj.getFullYear() + '-' + month + '-' + date;
    }

    var ComicCollection = function(element) {
        this.element = element;
        this.at = 0;

        var offset = 0;
        this.comics = Array(14).fill(null).map(function(_, i) {
            var date = new Date();

            date.setDate(new Date().getDate() - i - offset);

            // Skip next day if it is Sunday
            if (date.getDay() === 1) {
                offset++;
            }

            return getFormattedDate(date);
        });

        var self = this;

        if (this.element.attr('data-id')) {
            this.comics.forEach(function(date, i) {
                if (date == self.element.attr('data-id')) {
                    self.at = i;
                }
            });
        }

        this.update().activeButtons();

        this.element.on('click','.next', function() {
            self.next().update().activeButtons();
        }).on('click','.previous', function() {
            self.prev().update().activeButtons();
        });

        return this;
    };
    ComicCollection.prototype = {
        current: function() {
            return this.comics[this.at];
        },
        activeButtons: function() {
            this.element.find('.previous').removeClass('active');
            this.element.find('.next').removeClass('active');

            if(this.at !== 0) {
                this.element.find('.next').addClass('active');
            }
            if(this.at !== (this.comics.length-1)) {
                this.element.find('.previous').addClass('active');
            }

            return this;
        },
        update: function() {
            this.element.find('img').attr('src', 'https://api.e24.no/content/v1/comics/' + this.comics[this.at]).on('load',(_.bind(function() {
                this.element.find('.comic-strip').scrollLeft(0);
            }, this)));

            return this;
        },
        next: function (){
            if(this.comics.hasOwnProperty(this.at-1)) {
                this.at -= 1;
            }

            return this;
        },
        prev: function() {
            if(this.comics.hasOwnProperty(this.at+1)) {
                this.at += 1;
            }

            return this;
        }
    };

    function init() {
        var $lunch = $('#lunch');
        var comics = new ComicCollection($lunch);
        $lunch.on('click', '.facebook', function(e) {
            e.preventDefault();
            window.open(
                'https://www.facebook.com/sharer/sharer.php?u=https://e24.no/lunch/' + comics.current(),
                'facebook',
                'width=720,height=275,resizable,scrollbars=no,status=1'
            );
        }).on('click', '.twitter', function(e) {
            e.preventDefault();
            window.open(
                'https://twitter.com/share?url=https://e24.no/lunch/' + comics.current(),
                'twitter',
                'width=720,height=275,resizable,scrollbars=no,status=1'
            );
        }).on('click', '.comic-strip', function() {
            if(lib.isMobile()) {
                $(this).toggleClass('strip-zoom');
            }
        });
    }


    eventManager.once('e24-lunch-loaded', init);

    return { init: init };
});

